import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/watchlists/$watchlistIndex/$')({
	component: WatchlistSplashPage,
});

function WatchlistSplashPage() {
	const { watchlistIndex } = Route.useParams();

	return (
		<Navigate
			params={{
				watchlistIndex,
			}}
			to="/watchlists/$watchlistIndex/overview"
		/>
	);
}
